import { useEffect, useState } from 'react';

import { postIncodeVerificationUrl } from 'PrivateApis';

import { APIResponseStatus } from 'Services/api.types';

import { useVehicleCollectionSub } from 'Containers/app/vehicleCollection/hooks/useVehicleCollectionSub';

import { authorizationHeader } from '../../../vehicleCollection/services/apiClient';

type IncodeVerificationUrl = Partial<{
  authToken: string;
  dpEnquiryId: number;
  incodeSDKFlow: boolean;
  onError: () => void;
}>;

export const useIncodeVerificationUrl = ({
  authToken,
  dpEnquiryId,
  incodeSDKFlow,
  onError,
}: IncodeVerificationUrl) => {
  const { offer, offerStatus } = useVehicleCollectionSub();
  const [loading, setLoading] = useState<boolean>(true);
  const [incodeUrl, setIncodeUrl] = useState<string>();

  const isOnFinance = offer?.data?.finance?.isVehicleOnFinance;

  useEffect(() => {
    const abortController = new AbortController();

    if (offerStatus !== APIResponseStatus.SUCCESS) {
      return () => {};
    }

    if (!authToken || !dpEnquiryId) {
      setLoading(false);
      return onError?.();
    }

    postIncodeVerificationUrl(dpEnquiryId, authorizationHeader(authToken), { isOnFinance, mode: incodeSDKFlow ? 'sdk' : 'redirect' }, abortController)
      .then((data) => setIncodeUrl(data?.redirectUrl))
      .catch((err) => {
        window?.Sentry?.captureException?.(err);
        onError?.();
      })
      .finally(() => setLoading(false));

    return () => {
      abortController?.abort();
    };
  }, [authToken, dpEnquiryId, onError, incodeSDKFlow, offerStatus]);

  return {
    incodeUrl,
    loading,
  };
};
